export default {
    // КАРТОЧКИ РАЗНЫЕ
    sbiv_1_a: {
        grade: 1, type: 'island', subtype: 'snowman', src: `/../images/ver2/snowman/extras/sbiv.png`,
        title: 'Сбив Обычный',
        discription: 'Ваша способность сбивать противника',     
    },
}